import { dashboardConstants, commonConstants } from "../_constants";
import { apiCall } from "../_helpers";
import { appNotification } from "../_components";
import qs from "qs";

const {
  GET_ALL_TERMINAL_SUMMARY_START,
  GET_ALL_TERMINAL_SUMMARY_SUCCESS,
  GET_ALL_TERMINAL_SUMMARY_FAILED,
  FILTER_TERMINAL_SUMMARY_START,
  FILTER_TERMINAL_SUMMARY_SUCCESS,
  FILTER_TERMINAL_SUMMARY_FAILED,
} = dashboardConstants;

const { SUCCESSFUL_CODE, GLOBAL_LOADING_START, GLOBAL_LOADING_ENDED } =
  commonConstants;

const getTerminals = (pageNumber, pageSize = 10) => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_TERMINAL_SUMMARY_START });
    const url = `/api/v1/terminal/summary?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    apiCall
      .get(url)
      .then((response) => {
        console.log(response.data);
        const { responseCode, responseMessage, count, content } = response.data;

        // if (!count) {
        //   console.log("error is here");
        //   const error = {
        //     errorMessage: responseMessage,
        //   };
        //   dispatch({ type: GET_ALL_TERMINAL_SUMMARY_FAILED, payload: error });
        //   dispatch({ type: GLOBAL_LOADING_ENDED });
        //   return;
        // }
        dispatch({
          type: GET_ALL_TERMINAL_SUMMARY_SUCCESS,
          payload: { content, count },
        });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_ALL_TERMINAL_SUMMARY_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const filterTerminals = (pageSize, filter) => {
  return (dispatch) => {
    dispatch({ type: FILTER_TERMINAL_SUMMARY_START });
    const url = `/api/v1/terminal/summary?pageSize=${pageSize}`;

    const params = qs.stringify(filter);
    const finalUrl = `${url}&${params}`;

    apiCall
      .get(finalUrl)
      .then((response) => {
        const { count, content } = response.data;
        if (count === 0) {
          dispatch({
            type: FILTER_TERMINAL_SUMMARY_SUCCESS,
            payload: { content, count },
          });
          appNotification(
            "No data found for these filter values",
            "Terminal summary not found",
            "error"
          );
          dispatch({ type: FILTER_TERMINAL_SUMMARY_FAILED });
          return;
        }

        if (count > 0) {
          dispatch({
            type: FILTER_TERMINAL_SUMMARY_SUCCESS,
            payload: { content, count },
          });
        } else {
          const error = { errorMessage: response.data.errorMessage };
          dispatch({ type: FILTER_TERMINAL_SUMMARY_FAILED, payload: error });
          return;
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message}. Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to filter Terminal summary",
          "error"
        );
        dispatch({
          type: FILTER_TERMINAL_SUMMARY_FAILED,
          payload,
        });
      });
  };
};

export const dashboardActions = {
  getTerminals,
  filterTerminals,
};

export default dashboardActions;
